import * as React from 'react';

import { withAppContext, IAppContext } from '../../shared/app-context';

import { localization, LocHelperInstance, langChangedName } from '../../shared/localization/localization';
import { ILogoGalleryImageData } from '../../shared/components/gallery/logo-gallery-image.component';
import { LogoGallery } from 'src/App/shared/components/gallery/logo-gallery.component';
import { DebuggerInstance } from 'src/App/shared/debugger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export interface ILogoEditorGalleryComponentProps {
    appContext: IAppContext;

    onImageSelected(imageId: string): void;
    onBack(): void;
    onUploadLogo(): void;
}

export interface ILogoEditorGalleryComponentState {
    images: ILogoGalleryImageData[];
    isLoading: boolean;
}

/**
 * Razeni pozic obrazku je na zaklade indexu v 'images'
 */
class LogoEditorGalleryComponent extends React.PureComponent<ILogoEditorGalleryComponentProps,ILogoEditorGalleryComponentState> {
    private langUpdateHandle = () => {this.setState({}); };

    constructor(props: ILogoEditorGalleryComponentProps) {
        super(props);
        this.state = {
            images: [],
            isLoading: false
        };
    }

    public componentDidMount() {
        LocHelperInstance.langChanged.addListener(langChangedName, this.langUpdateHandle);

        this.langUpdateHandle();
    }

    public componentWillUnmount() {
        LocHelperInstance.langChanged.removeListener(langChangedName, this.langUpdateHandle);
    }

    private handleImageSelected(id: string): void {
        DebuggerInstance.log(`Selected Image: ${id}`);
        this.props.onImageSelected(id);
    }

    private handleEmptyGallery(): void {
        this.props.onUploadLogo();
    }

    public render() {
        return (
            <div className="logo-editor-gallery-root">
                <div className="container justify-content-center">
                    <div className="row row-info">
                        <span>{localization.editorLoc.galleryInfo}</span>
                        <div className="primary-style dialog-close-container">
                        <button onClick={() => this.props.onBack()}>
                            <FontAwesomeIcon icon={faTimes} color={'black'} />
                        </button>
                    </div>
                    </div>
                    <div className="row">
                        <div className="gallery-content">
                            <LogoGallery
                                showDeleteBtn={false}
                                excludeMotives={true}
                                onLogoSelected={(id) => this.handleImageSelected(id)}
                                onEmptyGallery={() => this.handleEmptyGallery()}
                                />
                        </div>
                    </div>
                    <div className="row lg-row-buttons justify-content-center">
                        <button className="btn primary-style" onClick={() => this.props.onBack()}>{localization.commonLoc.back}</button>
                        <button className="btn primary-style" onClick={() => this.props.onUploadLogo()}>{localization.editorLoc.logoEditorContent.galleryUploadButton}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export const LogoEditorGallery = withAppContext(LogoEditorGalleryComponent);



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-gallery.component.tsx